import React from "react";
import Auth0ProviderWithHistory from "./src/Components/auth0-provider-with-history";

export const wrapRootElement = ({ element }) => {
  return <Auth0ProviderWithHistory>{element}</Auth0ProviderWithHistory>;
};
